import App from './App.svelte';

import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
momentDurationFormatSetup(moment)

import './api/playersmenu.js';

window.wait = time => new Promise(resolve => setTimeout(resolve, time))

moment.locale('ru');

// Устанавливаем document.cloud если не задан (для картинок в маркетплейсе)
if (!document.cloud) {
    document.cloud = "https://cdn.just-rp.online/cdn-ra3.ragemp.pro/cloud/";
}

const app = new App({
	target: document.body,
});

export default app;
import "./fonts-unify.css";
